import { AlphaOCircleIcon } from './AlphaOCircleIcon';

/**
 * author: Contributors
 * id 5DB486E7-89A5-45A6-8926-007B37DBC7D9
 * name alpha-o-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-o-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetOCircleIcon = AlphaOCircleIcon;
export default AlphabetOCircleIcon